import { render } from "./AlSides.vue?vue&type=template&id=2c1a6884&scoped=true"
import script from "./AlSides.vue?vue&type=script&lang=js"
export * from "./AlSides.vue?vue&type=script&lang=js"

import "./AlSides.vue?vue&type=style&index=0&id=2c1a6884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1a6884"]])

export default __exports__